<template>
  <div>
    <CCard>
      <CCardHeader>
        <div>
          <TextScroll :isVis="isVis" :dataList="textArr" @handlerNotice="getAnnouncement"></TextScroll>
        </div>
        <slot name="header">
          <div class="box">
            <div class="wrp">
              <div class="i-group">
                <!-- <div>{{ $t('CardDetail.Card') }}</div> -->
                <div class="i-input">
                  <input
                    type="text"
                    v-model="forms.card"
                    :placeholder="$t('CardDetail.Card')"
                    class="input"
                  />
                </div>
              </div>
              <div class="i-group" v-if="isSubAccount">
                <!-- <div>{{ $t('CardDetail.Card') }}</div> -->
                <div class="i-input">
                  <input
                    type="text"
                    v-model="forms.sub_user_name"
                    :placeholder="$t('SubAccount.TransactionSearchSubAccountName')"
                    class="input"
                  />
                </div>
              </div>
              <div class="i-group lg sm-qu-margin">
                <!-- <div>{{ $t('CardDetail.Tag') }}</div> -->
                <div class="i-input">
                  <input
                    type="text"
                    v-model="forms.tag"
                    :placeholder="$t('CardDetail.Tag')"
                    class="input"
                  />
                </div>
              </div>
              <div class="i-group lg sm-qu-margin">
                <!-- <div>{{ $t('CardDetail.Tag') }}</div> -->
                <div class="i-input">
                  <input
                    type="text"
                    v-model="forms.merchant"
                    :placeholder="$t('CardDetail.MerchantKeywords')"
                    class="input"
                  />
                </div>
              </div>
              <div class="i-group lg sm-qu-margin">
                <div class="i-input">
                  <el-date-picker
                    style="width:190px"
                    v-model="forms.afterDate"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('CardDetail.AfterDate')"
                  >
                  </el-date-picker>
                  
                </div>
              </div>
              <div class="i-group lg sm-qu-margin">
                <div class="i-input">
                  <el-date-picker
                    style="width:190px"
                    v-model="forms.beforeDate"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('CardDetail.BeforeDate')"
                  >
                  </el-date-picker>
                </div>
              </div>

              <div class="i-group lg sm-qu-margin">
                <!-- <div>{{ $t('CardDetail.Table.Status') }}</div> -->
                <div class="i-input">
                  <el-select
                    style="width:115px"
                    v-model="forms.status"
                    :placeholder="$t('CardDetail.SelectStatus')"
                  >
                    <el-option label="All" value="All"></el-option>
                    <!-- <el-option label="Pending" value="Pending"></el-option>
                    <el-option label="Complete" value="Complete"></el-option>
                    <el-option label="Decline" value="Decline"></el-option> -->
                    <el-option label="Authorized" value="Authorized"></el-option>
                    <el-option label="Settled" value="Settled"></el-option>
                    <el-option label="Declined" value="Declined"></el-option>
                  </el-select>
                  <!-- <select name="select" id="select" class="sel" v-model="forms.status">
                     <option value="Pending">Pending</option>
                     <option value="Complete">Complete</option>
                     <option value="Decline">Decline</option>
                    </select>    -->
                </div>
              </div>

              <!-- <div class="i-group lg sm-qu-margin">
                <div class="i-input">
                  <el-select v-model="forms.type" :placeholder="$t('CardDetail.SelectType')">
                    <el-option :label="$t('CardDetail.TypeLabel1')" value="Auth"></el-option>
                    <el-option :label="$t('CardDetail.TypeLabel2')" value="Reversal"></el-option>
                    <el-option :label="$t('CardDetail.TypeLabel3')" value="Refund"></el-option>
                </el-select>
                </div>
              </div> -->
              <!-- <div class="i-group lg sm-qu-margin" >
                <div>{{ $t('CardDetail.Cardholder') }}</div>
                <div class="i-input">
                  <input
                    type="text"
                    v-model="forms.carder"
                    :placeholder="$t('CardDetail.CPlaceHolder')"
                    class="input"
                  />
                </div>
              </div> -->
              <!-- <div class="i-group lg sm-qu-margin" >
                <div>{{ $t('CardDetail.Amount') }}</div>
                <div class="i-input">
                   <select name="select" id="select" class="sel" v-model="forms.selectOptions">
                     <option value="<">&gt;</option>
                     <option value=">">&lt;</option>
                     <option value="=">=</option>
                    </select>   
                </div>
                <div class="i-input">
                  <input
                    type="text"
                    v-model="forms.amount"
                    :placeholder="$t('CardDetail.Amount')"
                    class="input"
                    @keyup="vaildAmount"
                  />
                </div>
              </div> -->
              <div style="margin-left: 10px" class="i-group lg sm-qu-margin">
                <div>
                  <!-- <CButton color="primary" style="padding: 6px 20px" shape="pill">
                  <CIcon name="cilMagnifyingGlass" />
                </CButton> -->
                  <button class="s-btn" @click="search">
                    <!-- <CIcon name="cilMagnifyingGlass" /> -->
                    <!-- {{ $t("CardDetail.Search") }} -->
                    <CIcon name="cilMagnifyingGlass" />
                  </button>
                </div>
                <div @click="clear">
                  
                  <!-- <CButton color="primary" style="padding: 6px 20px" shape="pill">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="height:16px">
                    <polygon fill="var(--ci-primary-color, currentColor)" points="427.314 107.313 404.686 84.687 256 233.373 107.314 84.687 84.686 107.313 233.373 256 84.686 404.687 107.314 427.313 256 278.627 404.686 427.313 427.314 404.687 278.627 256 427.314 107.313" class="ci-primary"/>
                  </svg>
                </CButton> -->
                  <button class="s-btn" style="margin-left:10px">
                    <!-- {{ $t("CardDetail.Clear") }} -->
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="height:16px">
                    <polygon fill="var(--ci-primary-color, currentColor)" points="427.314 107.313 404.686 84.687 256 233.373 107.314 84.687 84.686 107.313 233.373 256 84.686 404.687 107.314 427.313 256 278.627 404.686 427.313 427.314 404.687 278.627 256 427.314 107.313" class="ci-primary"/>
                  </svg>
                  </button>
                </div>
              </div>
              <div style="text-align:right;margin-top:12px">
              <a style="color: #1675D4;margin-left:20px" :href="`${ori}/user-guide/${getLa}/fund-detail/VirtualCard.html`" target="_blank">{{$t('CardDetail.Guide')}}</a>
            </div>
            </div>
            
          </div>
        </slot>
      </CCardHeader>
      <CCardBody>
        <CDataTable
          :hover="hover"
          :striped="striped"
          :small="small"
          :fixed="fixed"
          :items="items"
          :fields="tableFields"
          :dark="dark"
          pagination
          :items-per-page="20"
        >
          <template #status="{ item }">
            <td>
              <div class="res">
                <!-- <CBadge :color="getBadge(item.status)">{{
                  item.status
                }}</CBadge> -->
                <span :style="`background: ${getBadge(item.status)}`" class="statuscolor">{{ item.status }}</span>
                <div v-if="item.status == 'Declined'" style="padding-left: 10px">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.decline_reason"
                    placement="bottom"
                  >
                    <span class="res-span">?</span>
                  </el-tooltip>
                  <!-- <CButton
                    style="padding: 0"
                    v-c-tooltip="{
                      content: `${item.decline_reason}`,
                      placement: 'bottom',
                    }"
                  >
                    <span class="res-span">?</span>
                  </CButton> -->
                </div>
              </div>
            </td>
          </template>
          <template #Card="{ item }">
            <td style="cursor: pointer" @click="showM">{{ item.Card }}</td>
          </template>
          <template #merchant_name="{ item }">
            <td>
              <div class="csu-box">
                <!-- <div><CIcon name="cart"></CIcon></div> -->
                <!-- <shopping theme="outline" size="24" fill="#949494" /> -->
                <!-- :style="
                    item.type == 'Reversal'
                      ? 'color: #E3E3E3 !important'
                      : '#75758B !important'
                  " -->
                <div>
                  {{ item.merchant_name }}
                </div>
              </div>
            </td>
          </template>
          <template #card_number="{ item }">
            <td style="">
              <!-- <div>
                      <div>{{item.ConsumerCard.name}}</div>
                      <div style="font-size: 14px;color: #CED2D8">{{fotmastStemplate(item.ConsumerCard.code)}}</div>
                  </div> -->
              <div style="cursor: pointer" @click="showM">
                <div class="icon-box">
                  <div>
                    <!-- item.card_number.includes('222929')
                          ? '#F57950'
                          : '#728EFF' -->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      :fill="
                        setCardColor(item.card_number)
                      "
                      style="height: 42px"
                    >
                      <rect
                        width="256"
                        height="42"
                        x="128"
                        y="192"
                        class="ci-primary"
                      />
                      <rect
                        width="128"
                        height="42"
                        x="128"
                        y="304"
                        class="ci-primary"
                      />
                      <path
                        d="M48,432H464V88H48ZM80,120H432V400H80Z"
                        class="ci-primary"
                      />
                    </svg>
                  </div>
                  <div class="tds">
                    <!-- <CIcon name="cib-visa" /> -->
                    <div class="tds-name-box">
                      <div style="display:none">
                        {{ item.alias }}
                      </div>
                      <div v-if="isMasterIcon(item)">
                        <!-- <svg width="32" height="25" fill="#F99F1B" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 32 32" role="img">undefined<path d="M15.125 24.041c0.077 0.063 0.161 0.131 0.239 0.193-1.567 1.047-3.452 1.651-5.473 1.651-5.464 0-9.891-4.421-9.891-9.885 0-5.459 4.427-9.885 9.885-9.885 2.027 0 3.912 0.604 5.475 1.645-0.079 0.068-0.157 0.136-0.22 0.204-2.337 2.020-3.681 4.953-3.681 8.036s1.339 6.016 3.667 8.041zM22.115 6.115c-2.032 0-3.912 0.604-5.475 1.645 0.079 0.068 0.157 0.136 0.22 0.204 2.337 2.020 3.681 4.953 3.681 8.036 0 3.079-1.339 6.011-3.667 8.041-0.077 0.063-0.161 0.131-0.239 0.193 1.567 1.047 3.447 1.651 5.473 1.651 5.464 0 9.891-4.421 9.891-9.885 0-5.459-4.427-9.885-9.885-9.885zM16 8.235c-0.131 0.099-0.251 0.197-0.375 0.307-2.084 1.813-3.401 4.48-3.401 7.459s1.317 5.645 3.401 7.459c0.12 0.109 0.249 0.213 0.375 0.312 0.131-0.099 0.251-0.203 0.375-0.312 2.084-1.813 3.401-4.48 3.401-7.459s-1.317-5.645-3.401-7.459c-0.12-0.109-0.244-0.208-0.375-0.307z"></path></svg> -->
                        <svg style="transform: scale(1.5)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1661996271747" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="2507" width="32" height="25"><path d="M888 789H136c-39.76 0-72-32.24-72-72V307c0-39.76 32.24-72 72-72h752c39.76 0 72 32.24 72 72v410c0 39.76-32.24 72-72 72z" fill="#F7F9FB" p-id="2508"/><path d="M427.25 512m-134 0a134 134 0 1 0 268 0 134 134 0 1 0-268 0Z" fill="#EA001B" p-id="2509"/><path d="M596.75 512m-134 0a134 134 0 1 0 268 0 134 134 0 1 0-268 0Z" fill="#F79F1A" p-id="2510"/><path d="M463 512.25c0 41.71 19.06 78.97 48.94 103.54 30.24-24.57 49.56-62.05 49.56-104.04 0-41.71-19.06-78.97-48.94-103.54C482.32 432.78 463 470.25 463 512.25z" fill="#FF5F01" p-id="2511"/><path d="M719.58 579.14h1.67v4.35h0.75v-4.35h1.67v-0.65h-4.09zM728.66 578.49l-1.73 4.01h-0.02l-1.74-4.01h-0.9v5h0.76v-3.57h0.03l1.53 3.57h0.65l1.53-3.57h0.03v3.57h0.76v-5z" fill="#F79F1A" p-id="2512"/><path d="M363.05 678.16c-5.77-1.75-11.3-1.17-15.91 3.3-0.57 0.55-0.89 1.34-1.75 1.67-6.88-7.27-14.26-8.07-22.1-1.45-0.57-1.06 0.21-2.23-0.77-3.33-2.25-0.09-4.68-0.24-7.19 0.11v35.62h7.32c0.64-1.02 0.43-1.84 0.43-2.62 0.02-5.38 0-10.77 0.01-16.15 0-1.45 0.03-2.89 0.41-4.3 1.11-4.12 4.41-6.45 8.85-6.22 3.95 0.2 6.4 2.56 7.08 6.88 0.15 0.95 0.17 1.92 0.18 2.88 0.02 5.78 0.02 11.57 0.03 17.35 0 0.71-0.19 1.46 0.61 2.3 2.21-0.13 4.65 0.26 6.92-0.17 0.59-1.01 0.4-1.83 0.4-2.62 0.02-5.46 0.01-10.93 0.01-16.39 0-1.45 0.08-2.89 0.49-4.29 1.17-3.93 4.62-6.26 8.84-5.95 4.03 0.3 6.44 2.61 7.09 6.9 0.14 0.95 0.14 1.92 0.14 2.88 0.01 5.62-0.01 11.25 0.02 16.87 0 0.86-0.24 1.78 0.41 2.6h7.27c0.15-0.4 0.31-0.62 0.31-0.84-0.01-7.71 0.17-15.43-0.13-23.13-0.24-5.86-3.27-10.17-8.97-11.9zM700.84 664.03v17.84c-9.67-6.3-18.31-5.7-24.68 1.44-5.97 6.68-6.13 18.28-0.34 25.38 2.69 3.3 6.17 5.37 10.34 6.11 5.41 0.95 10.33-0.09 14.55-4.57 0.05 1.07 0.08 1.6 0.11 2.13 0.02 0.55-0.06 1.14 0.4 1.58 2.51 0.42 5.56 0.33 7.29-0.23v-49.9c-2.65 0.11-5.09-0.24-7.67 0.22z m-10.18 43.62c-6.22 0.12-10.89-4.66-10.94-11.22-0.05-6.81 4.4-11.65 10.74-11.68 6.2-0.02 10.78 4.77 10.84 11.35 0.05 6.62-4.38 11.43-10.64 11.55zM628.87 678.39c-0.93 1.14-0.01 2.32-0.96 3.45-3.35-3.6-7.59-4.85-12.36-4.44-4.87 0.42-8.91 2.51-12.07 6.23-5.72 6.73-5.79 18.07-0.13 25 2.63 3.22 6.01 5.35 10.09 6.11 5.46 1.01 10.5 0.1 14.51-4.16 0.9 1.21-0.07 2.52 0.94 3.47h7.27v-35.71c-2.65-0.08-5.08-0.24-7.29 0.05z m-10.75 29.26c-6.41-0.02-10.92-4.82-10.83-11.56 0.08-6.72 4.73-11.47 11.1-11.34 6.05 0.12 10.58 5.07 10.5 11.48-0.08 6.68-4.56 11.43-10.77 11.42zM408.58 678.44c-0.74 1.19 0.03 2.34-0.67 3.25-8.49-6.08-17.5-5.65-23.84 1.09-6.41 6.81-6.88 18.43-1.01 25.72 2.72 3.38 6.23 5.59 10.51 6.3 5.39 0.89 10.35-0.06 14.28-4.3 0.85 1.23-0.22 2.52 0.89 3.54h7.16v-35.77c-2.66 0.09-5.1-0.28-7.32 0.17z m-10.74 29.21c-6.47-0.11-10.85-4.87-10.72-11.65 0.12-6.66 4.66-11.33 10.92-11.24 6.19 0.09 10.75 5.06 10.63 11.57-0.14 6.71-4.64 11.43-10.83 11.32zM517.46 677.87c-6.85-1.9-14.38 0.57-18.53 6.17-4.11 5.55-4.69 11.84-2.92 18.34 1.9 6.95 6.66 11.01 13.63 12.36 3.74 0.73 7.53 0.53 11.2-0.62 2.74-0.85 5.32-2.03 7.39-4.24-1.3-1.93-2.49-3.69-3.66-5.43-11.74 5.59-19.74 3.73-21.03-5.3h26.22c0.6-2.52 0.41-4.68 0.03-6.8-1.27-7.21-4.99-12.45-12.33-14.48z m-13.73 14.86c0.29-4.75 3.85-8.14 8.63-8.32 5.12-0.19 8.53 2.76 9.32 8.32h-17.95zM450.36 694.79c-1.35-0.74-2.78-1.22-4.26-1.61-2.88-0.75-5.87-0.88-8.77-1.48-1.79-0.37-3.77-0.77-3.97-3.16-0.15-1.78 1.44-3.33 3.94-3.87 2.31-0.5 4.62-0.28 6.93 0.16 2.44 0.46 4.71 1.43 7.13 2.53 1.14-2.16 2.2-4.16 3.4-6.44-7.94-3.84-15.7-5.19-23.69-1.65-4.22 1.86-6.2 5.47-6 10.1 0.19 4.39 2.82 6.95 6.64 8.61 3.08 1.33 6.38 1.51 9.62 2.06 1.5 0.26 3.03 0.48 4.37 1.26 2.1 1.21 2.29 3.36 0.47 4.95-0.93 0.81-2.05 1.25-3.26 1.45-2.39 0.4-4.78 0.4-7.19 0.05-3.05-0.44-5.76-1.75-8.48-3.36l-3.48 5.77c0.23 0.36 0.29 0.52 0.4 0.62 0.18 0.16 0.39 0.28 0.59 0.4 6.18 3.88 12.92 4.57 19.93 3.38 2.96-0.5 5.67-1.71 7.87-3.88 4.87-4.82 3.82-12.59-2.19-15.89zM483.82 707.24c-5.32 1.27-7.79-0.72-7.8-6.18-0.01-4.25-0.02-8.51 0.01-12.76 0-0.86-0.25-1.77 0.63-2.87h11.92c0.34-2.46 0.25-4.59 0.03-7.24h-12.63v-10.66h-7.9v10.42c-2.49 0.7-4.86-0.11-7.24 0.62-0.16 2.25-0.28 4.45 0.05 6.65 2.41 0.61 4.79-0.19 6.93 0.54 0.42 1.01 0.25 1.91 0.26 2.77 0.02 4.9-0.06 9.79 0.04 14.69 0.08 4.09 1.15 7.82 4.9 10.15 4.41 2.75 12.9 2.14 17.23-1.27-0.68-2.1-1.18-4.32-2.32-6.3-1.55 0.55-2.8 1.13-4.11 1.44zM573.78 703.68c-3.37-3.84-3.49-10.64-0.24-14.6 5.35-6.51 11.66-4.75 18.01-1.27 1.23-2.03 2.39-3.92 3.52-5.78-3.7-5.34-18.08-7-25.83-0.17-7.59 6.69-8.25 20.03-1.14 27.58 6.61 7.02 20.85 7.68 27.03 1.07-1.15-1.91-2.33-3.88-3.57-5.94-6.26 3.49-12.41 5.23-17.78-0.89zM546.26 681.78c-0.7-1.25 0.11-2.41-0.78-3.4-2.28-0.22-4.65-0.18-7.22-0.01v35.68c2.63 0.19 5.05 0.23 7.7-0.04v-18.95c0-1.53-0.01-3.05 0.37-4.54 0.96-3.77 3.41-5.71 7.31-5.62 1.57 0.04 3.14 0.34 4.9 0.55 0.77-2.34 1.53-4.65 2.36-7.16-5.82-1.74-10.73-1.29-14.64 3.49zM654.62 681.82c-0.65-1.29 0.02-2.32-0.7-3.39h-7.18v35.66c2.64 0.06 5.06 0.3 7.65-0.17v-18.49c0-1.69 0.02-3.36 0.44-5.02 0.92-3.63 3.38-5.54 7.13-5.54 1.61 0 3.15 0.43 4.99 0.68 0.79-2.37 1.56-4.67 2.42-7.23-5.81-1.78-10.79-1.36-14.75 3.5zM727.11 711.74c0-0.74-0.79-0.99-1.89-0.99h-1.69v3.5h0.71v-1.47h0.95l1.27 1.47h0.81l-1.36-1.52c0.72-0.12 1.2-0.44 1.2-0.99z m-1.99 0.67h-0.88v-1.28h0.88c0.82 0 1.27 0.16 1.27 0.61 0.01 0.45-0.45 0.67-1.27 0.67z" p-id="2513"/><path d="M725.4 708.75c-2.07 0-3.75 1.68-3.75 3.75s1.68 3.75 3.75 3.75 3.75-1.68 3.75-3.75-1.68-3.75-3.75-3.75z m0 7c-1.79 0-3.25-1.46-3.25-3.25s1.46-3.25 3.25-3.25 3.25 1.46 3.25 3.25-1.46 3.25-3.25 3.25z" p-id="2514"/></svg>
                      </div>
                      <div v-else-if="isDicoverIcon(item)">
                        <img :src="discovericon" style="width:32px;height:32px;" alt="">
                      </div>
                      <div v-else>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="#3C58A5"
                        >
                          <path
                            d="M23.26 11.495c-0.515-0.192-1.323-0.401-2.323-0.401-2.557 0-4.364 1.292-4.375 3.141-0.021 1.359 1.281 2.125 2.265 2.583 1.011 0.469 1.349 0.761 1.344 1.177-0.005 0.641-0.808 0.927-1.547 0.927-1.027 0-1.584-0.14-2.443-0.5l-0.319-0.151-0.364 2.136c0.625 0.255 1.745 0.479 2.901 0.5 2.724 0 4.5-1.281 4.52-3.256 0.021-1.083-0.676-1.905-2.161-2.583-0.896-0.437-1.457-0.735-1.457-1.183 0-0.396 0.479-0.812 1.479-0.812 0.859-0.016 1.464 0.172 1.937 0.359l0.245 0.109 0.359-2.057zM29.907 11.271h-2c-0.625 0-1.089 0.167-1.365 0.787l-3.844 8.713h2.719l0.548-1.427 3.317 0.005c0.083 0.333 0.317 1.421 0.317 1.421h2.401zM12.88 11.193h2.589l-1.62 9.504h-2.589l1.62-9.509zM6.297 16.427l0.265 1.323 2.536-6.479h2.745l-4.084 9.484h-2.733l-2.24-8.031c-0.047-0.14-0.104-0.235-0.245-0.317-0.755-0.396-1.604-0.719-2.541-0.943l0.031-0.199h4.177c0.563 0.021 1.021 0.199 1.177 0.803l0.912 4.364zM26.703 17.401l1.037-2.661c-0.016 0.025 0.213-0.547 0.343-0.907l0.177 0.817 0.6 2.745h-2.157z"
                          />
                        </svg>
                      </div>
                      <!-- <CButton
                        style="padding: 0"
                        v-c-tooltip="{
                          content: `${item.tag}`,
                          placement: 'bottom',
                        }"
                      >
                        <i class="el-icon-price-tag"></i>
                      </CButton> -->
                      <el-tooltip effect="dark" :content="item.tag" placement="bottom">
                        <i class="el-icon-price-tag"></i>
                      </el-tooltip>
                    </div>
                    <div class="">
                      <!-- <div v-if="isMasterIcon(item)">
                        
                        <svg style="transform: scale(1.5)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" t="1661996271747" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="2507" width="32" height="25"><path d="M888 789H136c-39.76 0-72-32.24-72-72V307c0-39.76 32.24-72 72-72h752c39.76 0 72 32.24 72 72v410c0 39.76-32.24 72-72 72z" fill="#F7F9FB" p-id="2508"/><path d="M427.25 512m-134 0a134 134 0 1 0 268 0 134 134 0 1 0-268 0Z" fill="#EA001B" p-id="2509"/><path d="M596.75 512m-134 0a134 134 0 1 0 268 0 134 134 0 1 0-268 0Z" fill="#F79F1A" p-id="2510"/><path d="M463 512.25c0 41.71 19.06 78.97 48.94 103.54 30.24-24.57 49.56-62.05 49.56-104.04 0-41.71-19.06-78.97-48.94-103.54C482.32 432.78 463 470.25 463 512.25z" fill="#FF5F01" p-id="2511"/><path d="M719.58 579.14h1.67v4.35h0.75v-4.35h1.67v-0.65h-4.09zM728.66 578.49l-1.73 4.01h-0.02l-1.74-4.01h-0.9v5h0.76v-3.57h0.03l1.53 3.57h0.65l1.53-3.57h0.03v3.57h0.76v-5z" fill="#F79F1A" p-id="2512"/><path d="M363.05 678.16c-5.77-1.75-11.3-1.17-15.91 3.3-0.57 0.55-0.89 1.34-1.75 1.67-6.88-7.27-14.26-8.07-22.1-1.45-0.57-1.06 0.21-2.23-0.77-3.33-2.25-0.09-4.68-0.24-7.19 0.11v35.62h7.32c0.64-1.02 0.43-1.84 0.43-2.62 0.02-5.38 0-10.77 0.01-16.15 0-1.45 0.03-2.89 0.41-4.3 1.11-4.12 4.41-6.45 8.85-6.22 3.95 0.2 6.4 2.56 7.08 6.88 0.15 0.95 0.17 1.92 0.18 2.88 0.02 5.78 0.02 11.57 0.03 17.35 0 0.71-0.19 1.46 0.61 2.3 2.21-0.13 4.65 0.26 6.92-0.17 0.59-1.01 0.4-1.83 0.4-2.62 0.02-5.46 0.01-10.93 0.01-16.39 0-1.45 0.08-2.89 0.49-4.29 1.17-3.93 4.62-6.26 8.84-5.95 4.03 0.3 6.44 2.61 7.09 6.9 0.14 0.95 0.14 1.92 0.14 2.88 0.01 5.62-0.01 11.25 0.02 16.87 0 0.86-0.24 1.78 0.41 2.6h7.27c0.15-0.4 0.31-0.62 0.31-0.84-0.01-7.71 0.17-15.43-0.13-23.13-0.24-5.86-3.27-10.17-8.97-11.9zM700.84 664.03v17.84c-9.67-6.3-18.31-5.7-24.68 1.44-5.97 6.68-6.13 18.28-0.34 25.38 2.69 3.3 6.17 5.37 10.34 6.11 5.41 0.95 10.33-0.09 14.55-4.57 0.05 1.07 0.08 1.6 0.11 2.13 0.02 0.55-0.06 1.14 0.4 1.58 2.51 0.42 5.56 0.33 7.29-0.23v-49.9c-2.65 0.11-5.09-0.24-7.67 0.22z m-10.18 43.62c-6.22 0.12-10.89-4.66-10.94-11.22-0.05-6.81 4.4-11.65 10.74-11.68 6.2-0.02 10.78 4.77 10.84 11.35 0.05 6.62-4.38 11.43-10.64 11.55zM628.87 678.39c-0.93 1.14-0.01 2.32-0.96 3.45-3.35-3.6-7.59-4.85-12.36-4.44-4.87 0.42-8.91 2.51-12.07 6.23-5.72 6.73-5.79 18.07-0.13 25 2.63 3.22 6.01 5.35 10.09 6.11 5.46 1.01 10.5 0.1 14.51-4.16 0.9 1.21-0.07 2.52 0.94 3.47h7.27v-35.71c-2.65-0.08-5.08-0.24-7.29 0.05z m-10.75 29.26c-6.41-0.02-10.92-4.82-10.83-11.56 0.08-6.72 4.73-11.47 11.1-11.34 6.05 0.12 10.58 5.07 10.5 11.48-0.08 6.68-4.56 11.43-10.77 11.42zM408.58 678.44c-0.74 1.19 0.03 2.34-0.67 3.25-8.49-6.08-17.5-5.65-23.84 1.09-6.41 6.81-6.88 18.43-1.01 25.72 2.72 3.38 6.23 5.59 10.51 6.3 5.39 0.89 10.35-0.06 14.28-4.3 0.85 1.23-0.22 2.52 0.89 3.54h7.16v-35.77c-2.66 0.09-5.1-0.28-7.32 0.17z m-10.74 29.21c-6.47-0.11-10.85-4.87-10.72-11.65 0.12-6.66 4.66-11.33 10.92-11.24 6.19 0.09 10.75 5.06 10.63 11.57-0.14 6.71-4.64 11.43-10.83 11.32zM517.46 677.87c-6.85-1.9-14.38 0.57-18.53 6.17-4.11 5.55-4.69 11.84-2.92 18.34 1.9 6.95 6.66 11.01 13.63 12.36 3.74 0.73 7.53 0.53 11.2-0.62 2.74-0.85 5.32-2.03 7.39-4.24-1.3-1.93-2.49-3.69-3.66-5.43-11.74 5.59-19.74 3.73-21.03-5.3h26.22c0.6-2.52 0.41-4.68 0.03-6.8-1.27-7.21-4.99-12.45-12.33-14.48z m-13.73 14.86c0.29-4.75 3.85-8.14 8.63-8.32 5.12-0.19 8.53 2.76 9.32 8.32h-17.95zM450.36 694.79c-1.35-0.74-2.78-1.22-4.26-1.61-2.88-0.75-5.87-0.88-8.77-1.48-1.79-0.37-3.77-0.77-3.97-3.16-0.15-1.78 1.44-3.33 3.94-3.87 2.31-0.5 4.62-0.28 6.93 0.16 2.44 0.46 4.71 1.43 7.13 2.53 1.14-2.16 2.2-4.16 3.4-6.44-7.94-3.84-15.7-5.19-23.69-1.65-4.22 1.86-6.2 5.47-6 10.1 0.19 4.39 2.82 6.95 6.64 8.61 3.08 1.33 6.38 1.51 9.62 2.06 1.5 0.26 3.03 0.48 4.37 1.26 2.1 1.21 2.29 3.36 0.47 4.95-0.93 0.81-2.05 1.25-3.26 1.45-2.39 0.4-4.78 0.4-7.19 0.05-3.05-0.44-5.76-1.75-8.48-3.36l-3.48 5.77c0.23 0.36 0.29 0.52 0.4 0.62 0.18 0.16 0.39 0.28 0.59 0.4 6.18 3.88 12.92 4.57 19.93 3.38 2.96-0.5 5.67-1.71 7.87-3.88 4.87-4.82 3.82-12.59-2.19-15.89zM483.82 707.24c-5.32 1.27-7.79-0.72-7.8-6.18-0.01-4.25-0.02-8.51 0.01-12.76 0-0.86-0.25-1.77 0.63-2.87h11.92c0.34-2.46 0.25-4.59 0.03-7.24h-12.63v-10.66h-7.9v10.42c-2.49 0.7-4.86-0.11-7.24 0.62-0.16 2.25-0.28 4.45 0.05 6.65 2.41 0.61 4.79-0.19 6.93 0.54 0.42 1.01 0.25 1.91 0.26 2.77 0.02 4.9-0.06 9.79 0.04 14.69 0.08 4.09 1.15 7.82 4.9 10.15 4.41 2.75 12.9 2.14 17.23-1.27-0.68-2.1-1.18-4.32-2.32-6.3-1.55 0.55-2.8 1.13-4.11 1.44zM573.78 703.68c-3.37-3.84-3.49-10.64-0.24-14.6 5.35-6.51 11.66-4.75 18.01-1.27 1.23-2.03 2.39-3.92 3.52-5.78-3.7-5.34-18.08-7-25.83-0.17-7.59 6.69-8.25 20.03-1.14 27.58 6.61 7.02 20.85 7.68 27.03 1.07-1.15-1.91-2.33-3.88-3.57-5.94-6.26 3.49-12.41 5.23-17.78-0.89zM546.26 681.78c-0.7-1.25 0.11-2.41-0.78-3.4-2.28-0.22-4.65-0.18-7.22-0.01v35.68c2.63 0.19 5.05 0.23 7.7-0.04v-18.95c0-1.53-0.01-3.05 0.37-4.54 0.96-3.77 3.41-5.71 7.31-5.62 1.57 0.04 3.14 0.34 4.9 0.55 0.77-2.34 1.53-4.65 2.36-7.16-5.82-1.74-10.73-1.29-14.64 3.49zM654.62 681.82c-0.65-1.29 0.02-2.32-0.7-3.39h-7.18v35.66c2.64 0.06 5.06 0.3 7.65-0.17v-18.49c0-1.69 0.02-3.36 0.44-5.02 0.92-3.63 3.38-5.54 7.13-5.54 1.61 0 3.15 0.43 4.99 0.68 0.79-2.37 1.56-4.67 2.42-7.23-5.81-1.78-10.79-1.36-14.75 3.5zM727.11 711.74c0-0.74-0.79-0.99-1.89-0.99h-1.69v3.5h0.71v-1.47h0.95l1.27 1.47h0.81l-1.36-1.52c0.72-0.12 1.2-0.44 1.2-0.99z m-1.99 0.67h-0.88v-1.28h0.88c0.82 0 1.27 0.16 1.27 0.61 0.01 0.45-0.45 0.67-1.27 0.67z" p-id="2513"/><path d="M725.4 708.75c-2.07 0-3.75 1.68-3.75 3.75s1.68 3.75 3.75 3.75 3.75-1.68 3.75-3.75-1.68-3.75-3.75-3.75z m0 7c-1.79 0-3.25-1.46-3.25-3.25s1.46-3.25 3.25-3.25 3.25 1.46 3.25 3.25-1.46 3.25-3.25 3.25z" p-id="2514"/></svg>
                      </div>
                      <div v-else>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="#3C58A5"
                        >
                          <path
                            d="M23.26 11.495c-0.515-0.192-1.323-0.401-2.323-0.401-2.557 0-4.364 1.292-4.375 3.141-0.021 1.359 1.281 2.125 2.265 2.583 1.011 0.469 1.349 0.761 1.344 1.177-0.005 0.641-0.808 0.927-1.547 0.927-1.027 0-1.584-0.14-2.443-0.5l-0.319-0.151-0.364 2.136c0.625 0.255 1.745 0.479 2.901 0.5 2.724 0 4.5-1.281 4.52-3.256 0.021-1.083-0.676-1.905-2.161-2.583-0.896-0.437-1.457-0.735-1.457-1.183 0-0.396 0.479-0.812 1.479-0.812 0.859-0.016 1.464 0.172 1.937 0.359l0.245 0.109 0.359-2.057zM29.907 11.271h-2c-0.625 0-1.089 0.167-1.365 0.787l-3.844 8.713h2.719l0.548-1.427 3.317 0.005c0.083 0.333 0.317 1.421 0.317 1.421h2.401zM12.88 11.193h2.589l-1.62 9.504h-2.589l1.62-9.509zM6.297 16.427l0.265 1.323 2.536-6.479h2.745l-4.084 9.484h-2.733l-2.24-8.031c-0.047-0.14-0.104-0.235-0.245-0.317-0.755-0.396-1.604-0.719-2.541-0.943l0.031-0.199h4.177c0.563 0.021 1.021 0.199 1.177 0.803l0.912 4.364zM26.703 17.401l1.037-2.661c-0.016 0.025 0.213-0.547 0.343-0.907l0.177 0.817 0.6 2.745h-2.157z"
                          />
                        </svg>
                      </div> -->
                      <!-- <div style="margin-left: 10px">{{fotmastStr(item.ConsumerCard.code)}}</div> -->
                      <div style="" @click="clickStatic(item)">
                        {{ item.card_number }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </template>
          <template #auth_amt="{ item }">
            <td>
              <span :style="
                    item.auth_amt == 0
                      ? 'color: #E3E3E3 !important'
                      : '#75758B !important'
                  " :class="item.auth_amt > 0 ? 'auth-color' : 'ca'">
                {{ formatNum(item.auth_amt) }}
              </span>
              <span :style="
                    item.auth_amt == 0
                      ? 'color: #E3E3E3 !important'
                      : '#75758B !important'
                  ">
                {{ item.auth_currency }}
              </span>
            </td>
          </template>
          <template #settle_amt="{ item }">
            <td>
              <span :style="
                    item.auth_amt == 0
                      ? 'color: #E3E3E3 !important'
                      : '#75758B !important'
                  " :class="item.settle_amt > 0 ? 'auth-color' : 'ca'">
                ${{ formatNum(item.settle_amt) }}
              </span>
              <span>{{ item.settle_currency }}</span>
            </td>
          </template>
          <template #type="{ item }">
            <td>
              <!-- :style="item.type === 'Reversal' ? 'color: #E3E3E3' : ''" -->
              <div>
                {{ item.type }}<i style="margin-left: .5rem;cursor:pointer;font-weight:bold" v-if="item.type == 'TransactionFee'" class="el-icon-search" @click="seeTransactionFee(item.remark)"></i>
              </div>
            </td>
          </template>
          <!-- <template #auth_currency="{ item }">
            <td>
              <div :style="
                    item.auth_amt == 0
                      ? 'color: #E3E3E3 !important'
                      : '#75758B !important'
                  ">
                {{ item.auth_currency }}
              </div>
            </td>
          </template> -->
          <template #auth_time="{ item }">
            <td>
              <div>
                {{ item.auth_time }}
              </div>
            </td>
          </template>
          <!-- <template #Type>
              <td>
                  <CButton block color="secondary" variant="outline">消費授權</CButton>
              </td>
          </template> -->
        </CDataTable>
      </CCardBody>
      <CCardFooter>
        <!-- <CPagination
          align="center"
          :pages="pages"
          :active-page.sync="currentPage"
          @pagination-change="handerPage"
        /> -->
        <!-- <MyPagination :total="pages" @currentPage="handerPage">

        </MyPagination> -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pages"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="20"
          @current-change="handerPage"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </CCardFooter>
    </CCard>

    <!-- TransactionFee交易记录 -->
    <div>
      <CModal
        title=""
        :show.sync="showTransationFee"
        size=""
        :closeOnBackdrop="false"
      >
        <div class="modal-bodys">
          <div class="box-content">
            <CRow>
              <CCol md="6">
                <div class="m-item" style="padding-left:20px">
                  <div class="m-item-text">
                    {{ $t("AccountDetail.Statistics.CardNumber") }}
                  </div>
                  <div class="m-item-value">{{ transactionFeeData.card_number }}</div>
                </div>
              </CCol>
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("AccountDetail.Statistics.Merchant") }}
                  </div>
                  <div class="m-item-value">{{ transactionFeeData.merchant_name }}</div>
                </div>
              </CCol>
              <CCol md="6">
                <div class="m-item" style="padding-left:20px">
                  <div class="m-item-text">
                    {{ $t("AccountDetail.Statistics.Amount") }}
                  </div>
                  <div class="m-item-value">{{ transactionFeeData.auth_amt }}</div>
                </div>
              </CCol>
              <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("AccountDetail.Statistics.Status") }}
                  </div>
                  <div class="m-item-value">
                    <!-- ${{ showTData.available_amount }} -->
                    {{ transactionFeeData.status }}
                  </div>
                </div>
              </CCol>
              <CCol md="12">
                <CListGroup flush>
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("AccountDetail.Statistics.TransactionTime") }}：<span
                        style="font-weight: bold"
                        >{{ transactionFeeData.auth_time }}</span
                      >
                    </div></CListGroupItem
                  >
                  <!-- <CListGroupItem
                    ><div class="list-item">
                      {{ $t("AccountDetail.StaticFeild.TotalRefund") }}：<span
                        style="font-weight: bold"
                        >2324243</span
                      >
                    </div></CListGroupItem
                  > -->
                </CListGroup>
              </CCol>
            </CRow>
          </div>
        </div>
        <template #footer>
          <CButton
            color=""
            @click="cancelSee"
            style="background: #fff; border: 1px solid #e8e8e8"
          >
            {{ $t("AccountDetail.Statistics.Close") }}
          </CButton>
        </template>
      </CModal>
    </div>

    <!-- 统计弹窗 -->
    <div>
      <CModal
        :title="$t('VirtualCard.StaticFeild.Statistic')"
        :show.sync="showStatic"
        size=""
        :closeOnBackdrop="false"
      >
        <div class="modal-bodys">
          <div class="box-content">
            <CRow>
              <CCol md="6">
                <div class="m-item" style="padding-left:20px">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Card") }}
                  </div>
                  <div class="m-item-value">{{ clickStaticData.card_number }}
                    <!-- <CBadge :color="getBadge(clickStaticData.status)">{{
                      clickStaticData.status
                    }}</CBadge> -->
                    <!-- <span :style="`background: ${getBadgeDetail(detailStatus)}`" class="statuscolor">{{ detailStatus }}</span> -->
                    <CBadge :color="getBadgeDetail(detailStatus)">{{
                      detailStatus
                    }}</CBadge>
                  </div>
                </div>
              </CCol>
              <!-- <CCol md="6">
                <div class="m-item">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.CardName") }}
                  </div>
                  <div class="m-item-value">{{ clickStaticData.alias }}</div>
                </div>
              </CCol> -->
              <CCol md="6">
                <div class="m-item" style="padding-left:20px">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Tag") }}
                  </div>
                  <div class="m-item-value">{{ clickStaticData.tag }}</div>
                </div>
              </CCol>
              <CCol md="6">
                <div class="m-item" style="padding-left:20px">
                  <div class="m-item-text">
                    {{ $t("VirtualCard.ModalFeild.Balance") }}
                  </div>
                  <div class="m-item-value">
                    <!-- ${{ showTData.available_amount }} -->
                    ${{ formatNum(staticBalance) }}
                  </div>
                </div>
              </CCol>
              <CCol md="12">
                <div class="m-item" style="padding-left:20px">
                  <div class="m-item-text">
                    {{ $t("ceNavbar.CardHolder") }}
                  </div>
                  <div class="m-item-value">{{ cardHolder }}</div>
                </div>
              </CCol>
              <CCol md="12">
                <CListGroup flush>
                  <CListGroupItem
                  v-if="orderAddress !== null"
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.OrderAddress") }}：<span
                        style="font-weight: bold"
                        >{{orderAddress.address}},{{orderAddress.city}},{{orderAddress.state}},{{orderAddress.zip}}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.TotalTopup") }}：<span
                        style="font-weight: bold"
                        >$ {{ formatNum(staticInfoData.topup) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.TotalRefund") }}：<span
                        style="font-weight: bold"
                        >$ {{ formatNum(staticInfoData.refund) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.AuthorizedTimes") }}：<span
                        style="font-weight: bold"
                        >{{ staticInfoData.auth_num }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.AuthorizedAmount") }}：<span
                        style="font-weight: bold"
                        >$ {{ formatNum(staticInfoData.auth_amount) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                     {{ $t("VirtualCard.StaticFeild.DeclinedTimes") }}：<span
                        style="font-weight: bold"
                        >{{ staticInfoData.declined_num }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.DeclineRate") }}：<span :class="staticInfoData.declined_rate > 0.2 ? 'colorh' : ''"
                        style="font-weight: bold"
                        >{{ toPercent(staticInfoData.declined_rate) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem
                    ><div class="list-item">
                     <div>{{ $t("VirtualCard.StaticFeild.ReversRate") }}<el-tooltip placement="top">
                          <div slot="content">
                            <div>{{$t('VirtualCard.StaticFeild.ReversRateTip')}}</div>
                          </div>
                          <i style="cursor:pointer;color:#E6A23C;font-size:16px;vertical-align: -1px" class="el-icon-question"></i>
                        </el-tooltip>：</div><span
                        style="font-weight: bold"
                        >{{ toPercent(staticInfoData.revers_rate) }}</span
                      >
                    </div></CListGroupItem
                  >
                  <CListGroupItem>
                    <div class="list-item">
                      <div class="list-item">
                        <div>{{ $t("VirtualCard.StaticFeild.Reconciled") }}<el-tooltip placement="top">
                          <div slot="content">
                            <div>{{$t('VirtualCard.StaticFeild.ReconciledTip')}}</div>
                          </div>
                          <i style="cursor:pointer;color:#E6A23C;font-size:16px;vertical-align: -1px" class="el-icon-question"></i>
                        </el-tooltip>：</div>
                        
                      </div>
                      <span style="font-weight: bold">$ {{ formatNum(staticInfoData.reconcile_amount) }}</span>
                    </div>
                  </CListGroupItem>
                  <!-- <CListGroupItem
                    ><div class="list-item">
                      {{ $t("VirtualCard.StaticFeild.ReversedAmount") }}：<span
                        style="font-weight: bold"
                        >$ {{ formatNum(staticInfoData.revers_amount) }}</span
                      >
                    </div></CListGroupItem
                  > -->
                </CListGroup>
              </CCol>
            </CRow>
          </div>
        </div>
        <template #footer>
          <CButton
            color=""
            style="background: #fff; border: 1px solid #e8e8e8"
            @click="staticCancel"
          >
            {{ $t("VirtualCard.StaticFeild.Close") }}
          </CButton>
        </template>
      </CModal>
    </div>
  </div>
</template>

<script>
import { CDropdown } from "@coreui/vue";
import { Shopping } from "@icon-park/vue";
import "@icon-park/vue/styles/index.css";
import MyPagination from "../components/MyPagination.vue";
import { getCardDetail, getPageNotice, cardStatistic, getSingleCardDetail } from "../api/http"
import { CModal, CModalBody, CModalHeader, CModalFooter } from "@coreui/vue";
import TextScroll from "../components/TextScroll.vue"
import discovericon from "../assets/discover.png"
export default {
  name: "Table",
  props: {
    items: Array,
    fields: {
      type: Array,
      default() {
        return [
          { key: "ConsumerCard", label: "消費卡", _style: ";" },
          {
            key: "ConsumerTime",
            label: "消費時間",
            _style: "vertical-align: middle;",
          },
          {
            key: "ConsumerMerchant",
            label: "消費商戶",
            _style: "vertical-align: middle;",
          },

          { key: "AuthorizedAmount", label: "授權金額", _style: "" },
          { key: "AuthorizeType", label: "授權幣種", _style: "" },
          { key: "SettlementAmount", label: "結算金額", _style: "" },
          { key: "SettlementType", label: "結算幣種", _style: "" },
          { key: "Type", label: "類型", _style: "" },
          { key: "Status", label: "狀態", _style: "" },
        ];

        // return ['卡号', '持卡人', '有效期', '安全码', '余额', '已消费', '状态', '创建时间', '操作']
      },
    },
    caption: {
      type: String,
      default: "Table",
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    pages: Number,
    isSubAccount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visibleVerticallyCenteredDemo: false,
      flat: false,
      currentPage: 1,
      showStatic: false,
      discovericon,
      clickStaticData: "",
      staticInfoData: "",
      orderAddress: "",
      staticBalance: 0,
      detailStatus: "",
      cardHolder: '',
      pg: {
        pages: 20,
        activePage: 1,
        paginationChange(e) {
          console.log("pe==>", e);
        },
      },
      forms: {
        card: "",
        tag: "",
        carder: "",
        amount: null,
        selectOptions: "",
        beforeDate: "",
        afterDate: "",
        status: "All",
        type: "",
        merchant: '',
        sub_user_name: ''
      },
      options: ["<", ">", "="],
      ori: "",
      showTransationFee: false,
      transactionFeeData: "",
      textArr: [
        // {
        //   id:1,
        //   val:"卡详情"
        // }
      ],
      isVis: false
    };
  },
  computed: {
    getLa() {
      // return localStorage.getItem("lang")
      let la = this.$i18n.locale
      if(la == 'en') {
        return 'en-US'
      }else {
        return this.$i18n.locale
      }
    },
    tableFields() {
      const fields = [
        {
          key: "card_number",
          label: this.$t("CardDetail.Table.ConsumptionCard"),
          _style: ";",
        },
        {
          key: "auth_time",
          label: this.$t("CardDetail.Table.ConsumptionTime"),
          _style: "vertical-align: middle;",
        },
        {
          key: "merchant_name",
          label: this.$t("CardDetail.Table.ConsumerMerchant"),
          _style: "vertical-align: middle;width:190px",
        },

        {
          key: "auth_amt",
          label: this.$t("CardDetail.Table.AuthorizedAmount"),
          _style: "width:180px",
        },
        // {
        //   key: "auth_currency",
        //   label: this.$t("CardDetail.Table.AuthorizedCurrency"),
        //   _style: "",
        // },
        {
          key: "settle_amt",
          label: this.$t("CardDetail.Table.SettlementAmount"),
          _style: "width:180px",
        },
        // {
        //   key: "settle_currency",
        //   label: this.$t("CardDetail.Table.SettlementCurrency"),
        //   _style: "",
        // },
        { key: "type", label: this.$t("CardDetail.Table.Type"), _style: "" },
        {
          key: "status",
          label: this.$t("CardDetail.Table.Status"),
          _style: "",
        },
      ];
      return fields;
    },
  },
  methods: {
    isMasterIcon(e) {
      // Master Icon
      if(e.card_number.includes(222929) || e.card_number.includes(222934) || e.card_number.includes(556766) || e.card_number.includes(557271) || e.card_number.includes(540524) || e.card_number.includes(529587) || e.card_number.includes(538738) || e.card_number.includes(526144) || e.card_number.includes(417969) || e.card_number.includes(559666) || e.card_number.includes(556150) || e.card_number.includes(531993) || e.card_number.includes(534786) || e.card_number.includes(524897) || e.card_number.includes(559292) || e.card_number.includes(556371) || e.card_number.includes(519075) || e.card_number.includes(553370) || e.card_number.includes(556167) ||e.card_number.includes(553437) ||e.card_number.includes(256000) || e.card_number.includes(536025)|| e.card_number.includes(558325) || e.card_number.includes(545020)|| e.card_number.includes(527375) || e.card_number.includes(544923)) {
        return true
      }
      // VISA Icon
      else {
        false
      }
    },
    isDicoverIcon(e) {
      if(e.card_number.includes(658706)) {
        return true
      }else{
        return false
      }
    },
    // 金额每3位逗号隔开
    formatNum(value) {
      if (!value && value !== 0) return 0;

      let str = value.toString();
      let reg =
        str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg, "$1,");
    },
    // 小数转百分比显示
    toPercent(point){
    if (point==0) {
    return 0;
    }
    var str=Number(point*100).toFixed(2);
    str+="%";
    return str;
    },
    // 百分比轉爲小數
    toPoint(percent) {
      var str = percent.replace("%", "");
      console.log("str==>", str);
      str = str / 100;
      return str;
    },
    // 打开统计弹窗
    clickStatic(e) {
      console.log('static e==>', e)
      if(this.isSubAccount) return;
      this.reqStaticData(e)
      this.showStatic = true
      this.clickStaticData = e
      
      this.getCDetail(e)
      if(e.billing_address == null || e.billing_address == '') {
        this.orderAddress = null
      }else {
        this.orderAddress = e.billing_address
      }
      
    },
    // 关闭统计弹窗
    staticCancel() {
      this.showStatic = false
      this.$set(this.clickStaticData, "available_amount", this.staticBalance)
    },
    // 根据卡号获取卡统计数据
    reqStaticData(e) {
      let data = {
        type: "card_statistic",
        uid: window.localStorage.getItem('uid'),
        card_number: e.card_number,
      }
      cardStatistic(data).then((res) => {
        console.log('reqStaticData res==>', res)
        if(res.code == 200) {
          this.staticInfoData = res.data
        }else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取对应卡的详情
    getCDetail(e) {
      let data = {
        type: "get_card_details",
        uid: window.localStorage.getItem('uid'),
        card_number: e.card_number,
        card_id: e.card_id,
      }

      const detailParmas = this.isSubAccount ? { ...data, sub_uid: e.uid } : data;

      getSingleCardDetail(detailParmas).then((res) => {
        console.log('details res==>', res.data.balance)
        if(res.code == 200) {
          // this.refundBalance = res.data.balance
          // this.IncrementBalance = res.data.balance
          // this.deleteBalance = res.data.balance
          this.staticBalance = res.data.balance
          this.detailStatus = res.data.status
          this.cardHolder = res.data?.card_holder
        }else {
          this.$message.error(res.message)
        }
      })
    },
    // 请求通告数据
    getAnnouncement(noticeType) {
      let obj = {
        uid: window.localStorage.getItem("uid"),
        type: "get_page_notice",
        // page: "fund_fund"
        page: noticeType
      }
      getPageNotice(obj).then((res) => {
        console.log("notice==>", res)
        if(res.code == 200) {
          if(res.data.length !== 0) {
            this.isVis = true
            this.textArr = res.data
          }else {
            this.isVis = false
          }
        }
      })
    },
    formatNum(value) {
      if (!value && value !== 0) return 0;

      let str = value.toString();
      let reg =
        str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg, "$1,");
    },
    // 设置卡颜色
    setCardColor(card) {
      // 00BEA4 绿色  F57950 橙色  728EFF 蓝色
      return card.includes(428837)
        ? "#53B5EC"
        : card.includes(472593)
        ? "#FF7474"
        : card.includes(222929)
        ? "#19A389"
        : card.includes(556766)
        ? "#BD7BE8"
        : card.includes(222934)
        ? "#C5A561"
        : card.includes(540524)
        ? "#F6966C"
        : card.includes(538738)
        ? "#7BD7FF"
        : card.includes(526144)
        ? "#8BFF98"
        : card.includes(418122)
        ? "#E1797F"
        : card.includes(417969)
        ? "#E3CA7C"
        : card.includes(485932)
        ? "#7CA1D6"
        : card.includes(404038)
        ? "#3F3735"
        : card.includes(559666)
        ? "#2A3143"
        : card.includes(556150)
        ? "#653A44"
        : card.includes(450306)
        ? "#C1ADAE"
        : card.includes(446618)
        ? "#C1ADAE"
        : card.includes(557271)
        ? "#FF9FBD"
        : card.includes(256000)
        ? "#BD7BE8"
        : card.includes(486699)
        ? "#FF7474"
        : "#94B5C2"
    },
    getBadge(Status) {
      return Status === "Settled"
        ? "rgb(0,190,164)" // 绿色
        : Status === "Authorized"
        ? "rgb(46,184,92)" // 浅绿色
        : Status === "Pending"
        ? "rgb(51,153,255)" // 蓝色
        : Status === "Declined"
        ? "rgb(229,83,83)" // 红色
        : "rgb(79,93,115)"; // 深灰色
    },
    getBadgeDetail(Status) {
      // return Status === "Active"
      //   ? "rgb(0,190,164)" // 绿色
      //   : Status === "Authorized"
      //   ? "rgb(46,184,92)" // 浅绿色
      //   : Status === "Pending"
      //   ? "rgb(51,153,255)" // 蓝色
      //   : Status === "Declined"
      //   ? "rgb(229,83,83)" // 红色
      //   : "rgb(79,93,115)"; // 深灰色
      return Status === "Active"
        ? "success"
        : Status === "Issuing"
        ? "info"
        : Status === "Canceled"
        ? "danger"
        : Status === "Deleted"
        ? "danger"
        : Status === "Frozen"
        ? "warning"
        : "primary";
    },
    showM() {
      console.log("122");
      this.visibleVerticallyCenteredDemo = true;
    },
    fotmastStr(str) {
      return str.replace(/^(\d{4})\d+(\d{4})$/, "****$2");
    },
    getSelectOptions(e) {
      return (this.forms.selectOptions = e.target.value);
    },
    vaildAmount() {
      return (this.forms.amount = this.forms.amount.replace(/[^0-9.]/g, ""));
    },
    cancelSee() {
      this.showTransationFee = false
    },
    // 点击查看transactionFee交易记录
    seeTransactionFee(ref) {
      this.showTransationFee = true
      this.reqTransaction(ref)
    },
    reqTransaction(ref) {
      let data = {
        type: "get_card_transaction",
        uid: localStorage.getItem("uid"),
        tid: ref,
        before: "",
        after: "",
        card_number: "",
        tag: "",
        page: 1,
        page_size: 20
      }
      getCardDetail(data).then((res) => {
        // console.log("static res===>", res)
        if(res.data.length == 0) {
          this.transactionFeeData = {}
          return
        }
        if(res.code == 200) {
          this.transactionFeeData = res.data[0]
        }
      })
    },
    clear() {
      this.forms.card = "";
      this.forms.tag = "";
      this.forms.carder = "";
      this.forms.amount = null;
      this.forms.selectOptions = "";
      this.forms.tag = "";
      this.forms.beforeDate = "";
      this.forms.afterDate = "";
      this.forms.merchant = "";
      this.forms.status = "All";
      this.forms.sub_user_name = ''
      // this.forms.type = ""
    },
    search(car) {
      console.log('c==>', car)
      if(car !== "") {
        car = this.forms.card
      }else {
        car = ""
      }
      // before, after, card_number, tag
      if(this.isSubAccount) {
        this.$emit(
          "searchData",
          this.forms.beforeDate,
          this.forms.afterDate,
          // this.forms.card || c,
          this.forms.card || car,
          this.forms.tag,
          this.forms.status,
          this.forms.merchant,
          this.forms.sub_user_name,
          this.currentPage,
        );
      } else {
          this.$emit(
          "searchData",
          this.forms.beforeDate,
          this.forms.afterDate,
          // this.forms.card || c,
          this.forms.card || car,
          this.forms.tag,
          this.forms.status,
          this.forms.merchant,
          this.currentPage
        );
      }
      
    },
    // 切換頁碼
    handerPage(e) {
      console.log("page e", e);
      if(this.isSubAccount) {
        this.$emit(
        "searchData",
        this.forms.beforeDate,
        this.forms.afterDate,
        this.forms.card,
        this.forms.tag,
        this.forms.status,
        this.forms.merchant,
        this.forms.sub_user_name,
        e,
      );
      } else {
        this.$emit(
        "searchData",
        this.forms.beforeDate,
        this.forms.afterDate,
        this.forms.card,
        this.forms.tag,
        this.forms.status,
        this.forms.merchant,
        e
      );
      }
      
    },
    getCurrentPage2() {
      if(this.isSubAccount) {
        this.$emit(
        "searchData",
        this.forms.beforeDate,
        this.forms.afterDate,
        this.forms.card,
        this.forms.tag,
        this.forms.status,
        this.forms.merchant,
        this.forms.sub_user_name,
        this.currentPage,
      );
      } else {
        this.$emit(
        "searchData",
        this.forms.beforeDate,
        this.forms.afterDate,
        this.forms.card,
        this.forms.tag,
        this.forms.status,
        this.forms.merchant,
        this.currentPage
      );
      }
      
    },
    handleSizeChange(val) {
      console.log("val==>", val);
    },
  },
  created() {
    this.ori = window.location.origin
    this.forms.card = this.$route.params.card_num
    if(this.$route.params.card_num) {
      
      this.search(this.forms.card);
    }else {
      this.search(this.forms.card);
    }
    
    // else if(this.forms.card == "") {
    //   this.search(this.forms.card)
    // }
    // this.search(this.forms.card)
    // else {
    //   this.$route.params.card_num = ""
    //   this.search(this.forms.card)
    // }
    
    // if(this.$route.query.card_num) {
    //   this.forms.card = this.$route.query.card_num
    //   this.search()
    //   this.$route.query.card_num = undefined
    // }
    //  (this.items.length * this.currentPage) - 1
  },
  components: {
    CDropdown,
    CModal,
    CModalBody,
    CModalHeader,
    CModalFooter,
    Shopping,
    MyPagination,
    TextScroll
  },
};
</script>
<style scoped lang="scss">
.box-content {
  .m-item {
    padding: 0.3rem 0;
    .m-item-text {
      font-size: 13px;
    }
    .m-item-value {
      font-weight: bold;
    }
  }
}
.list-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.statuscolor {
    display: inline-block;
    padding: 0.25em 0.4em;
    line-height: 1;
    border-radius: .25rem;
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    text-align: center;
}
.box {
  margin-bottom: 10px;
}
.title {
  width: 150px;
}
.wrp {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  // .btn-ghost-info{
  //   color: #000 !important;
  // }
  .form-group {
    margin: 0;
  }
}
.ddd {
  color: #fff;
}
.ds {
  color: #000;
}
.con-box {
  padding-bottom: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.csu-box {
  display: flex;
  align-items: center;
}
.visa-box {
  display: flex;
  align-items: center;
}
.icon-box {
  display: flex;
  align-items: center;
  justify-content: start;
  // padding: 0 12px;
}
.tds {
  margin-left: 10px;
}
.input {
  border: 0;
  outline: 0;
  border-radius: 20px;
  padding: 4px 2px;
  text-indent: 10px;
  border: 1px solid #f1f1f2;
}
.i-group {
  display: flex;
  align-items: center;
  .i-input {
    margin-left: 10px;
  }
}
#select {
  border: 0;
  outline: 0;
  border: 1px solid #f1f1f2;
  border-radius: 20px;
  cursor: pointer;
}
.sel {
  display: block;
  width: 100%;
  padding: 5px 10px;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  color: #768192;
  background-color: #fff;
}
::-webkit-input-placeholder {
  color: #e3e3e3;
}
::-moz-placeholder {
  color: #e3e3e3;
}
.s-btn {
  border: 0;
  outline: 0;
  padding: 4px 20px;
  border-radius: 20px;
  background: transparent;
  border: 1px solid #f1f1f2;
}
.s-btn:hover {
  background: #00bea4;
  border-color: #00bea4;
  color: #fff;
  transition: all 0.5s linear;
}
.res {
  display: flex;
  align-items: center;
  .res-span {
    font-weight: bold;
    color: red;
    cursor: pointer;
    font-size: 1.3rem;
  }
}
.lg {
  margin-left: 0px;
}
@media screen and (max-width: 520px) {
  .sm-qu-margin {
    margin: 0;
  }
}
.tds-name-box {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  i {
    color: #00bea4;
    font-weight: bold;
    margin-left: 10px;
  }
}
.auth-color {
  color: #00bea4;
  font-weight: bold;
}
.ca{
  color: #FF1111;
  font-weight: bold;
}
</style>